import { jsxs as s, jsx as e } from "react/jsx-runtime";
import "react";
import '../../assets/AnchorTag.css';const o = {
  "anchor-tag--image": "_anchor-tag--image_1nb7n_1"
};
function g({
  href: l = "",
  classname: t = "",
  label: i = "",
  type: n = "internal-link",
  image: r = null,
  clickHandler: a = null
}) {
  return r !== null ? /* @__PURE__ */ s(
    "a",
    {
      href: l,
      className: [t, o["anchor-tag--image"], "anchor-tag--image"].join(" "),
      rel: n === "external-link" ? "noreferrer" : null,
      target: n === "internal-link" ? "_self" : "_blank",
      style: {
        "--anchor-tag-image-ratio": r.width / r.height
      },
      onClick: a && n === "internal-link" && l.includes("#") ? a : null,
      children: [
        /* @__PURE__ */ e("img", { src: r.url, alt: i }),
        /* @__PURE__ */ e("span", { className: "sr-only", children: i })
      ]
    }
  ) : /* @__PURE__ */ e(
    "a",
    {
      href: l,
      className: t,
      rel: n === "external-link" ? "noreferrer" : null,
      target: n === "internal-link" ? "_self" : "_blank",
      onClick: a && n === "internal-link" && l.includes("#") ? a : null,
      children: i
    }
  );
}
export {
  g as AnchorTag,
  g as default
};
